import request from '@/utils/request';

// 获取部门列表
export var getDepartmentList = function getDepartmentList(companyId, data) {
  return request({
    url: "/api/permission/Organize/".concat(companyId, "/Department"),
    method: 'GET',
    data: data
  });
};

// 获取部门下拉框列表(公司+部门)
export var getDepartmentSelector = function getDepartmentSelector(id) {
  return request({
    url: '/api/permission/Organize/Department/Selector/' + (!!id ? id : 0),
    method: 'GET'
  });
};

// 新建部门
export var createDepartment = function createDepartment(data) {
  return request({
    url: '/api/permission/Organize/Department',
    method: 'POST',
    data: data
  });
};

// 修改部门
export var updateDepartment = function updateDepartment(data) {
  return request({
    url: "/api/permission/Organize/Department/".concat(data.id),
    method: 'PUT',
    data: data
  });
};

// 获取部门信息
export var getDepartmentInfo = function getDepartmentInfo(id) {
  return request({
    url: "/api/permission/Organize/Department/".concat(id),
    method: 'GET'
  });
};

// 删除部门
export var delDepartment = function delDepartment(id) {
  return request({
    url: "/api/permission/Organize/Department/".concat(id),
    method: 'DELETE'
  });
};

// 更新部门状态
export var updateDepartmentState = function updateDepartmentState(id) {
  return request({
    url: "/api/permission/Organize/Department/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
};